module.exports = __webpack_public_path__ + "static/media/10.ea22ed55.png";